export const reduxKey = '@@AccountSettings';

